import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VisaService } from '../visa.service';
import {CountriesService} from '../../MasterData/countries.service';
import { VisaModel } from '../VisaModel';
import { CountriesModel } from '../../MasterData/CountriesModel';
import { VisaRequirementModel } from '../VisaRequirementModel';
import { VisaImagesModel } from '../VisaImagesModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    // moduleId: module.id,
    selector: 'visa-details',
    templateUrl: 'visa-details.component.html',
    styleUrls: ['visa-details.component.scss']
})
export class VisaDetailsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :VisaService,
          private modalServiceForImage: NgbModal,
          private CountriesService:CountriesService,
          private route: ActivatedRoute,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         
         ngOnInit() {
          this.lang = localStorage.getItem('theme_lang');
          debugger;
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.visaImagsList;
              this.Requirement=this.modelObject.visaRequirementList;
              console.log("modelObject",this.rows)
  
            })
  
          }
          else{
          }
  
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: VisaModel = new VisaModel();
      mainForm: FormGroup = new FormGroup({
        id: new FormControl(),
        images: new FormControl(),
        titleAr: new FormControl(),
        titleEn: new FormControl(),
        titleFr: new FormControl(),
        descriptionAr: new FormControl(),
        descriptionEn: new FormControl(),
        descriptionFe: new FormControl(),
        countryId: new FormControl(),
        userId: new FormControl(),
    });
  createForm(modelObject): FormGroup {
      debugger;
      return this.formBuilder.group({
        Id: [modelObject.Id >= 0 ? modelObject.Id : 0],
        comimagesment: [modelObject.images >= 0 ? modelObject.images : 0],
        countryId: [modelObject.countryId >= 0 ? modelObject.countryId : 0],
      });
    }
      rows :VisaModel[]= [];
      CountriesList :CountriesModel[]= [];
      Requirement:VisaRequirementModel[]=[];
      files:VisaImagesModel[]=[];

       public picurl: string ='';
       editEnabled = true;
        /**
  * Open modal for show the video
  * @param content content of modal
  */
  openWindowCustomClass(content) {
    this.modalServiceForImage.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }
     
       visaDetails(id){
          this.router.navigate(['/food-details/',id]);
          
        }
  }